import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserGrp } from '../../interfaces/master-model-interface';
import { AuthService } from '../../services/auth.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';



@Component({
  selector: 'app-sidenavbar',
  templateUrl: './sidenavbar.component.html',
  styleUrls: ['./sidenavbar.component.scss']
})



export class SidenavbarComponent implements OnInit, AfterViewInit {


  @Output() pinStateChanged = new EventEmitter<boolean>();

  public sidebarItems: any[] = [];
  public filteredSidebarItems: any[] = [];
  expandedItems: boolean[] = [];
  public isPinned = false;
  private openedFromSearch = false;

  groupName:string=''


  enterTimeout: any | undefined;
  leaveTimeout: any | undefined;
  nextTimeout: any | undefined;
  searchText = ''; // new property



  constructor(
    private Auth: AuthService,
    public router: Router,
    public window: Window,
    private sanitizer: DomSanitizer
  ) { }



  async ngOnInit() {

    Object.defineProperty(this, 'searchText', {
      set: (value: string) => {
        this._searchText = value;
        this.filterSidebarItems(this._searchText);
      },
      get: () => this._searchText
    });

  }



  private _searchText = '';



  ngAfterViewInit() {

    this.Auth.currentGrpSubject.subscribe(async (grp: UserGrp) => {
      const allSidebarItems = await this.Auth.GetSideMenu();
      this.sidebarItems = allSidebarItems.filter((item: any) => item.MenuType === 1);
      
      this.sidebarItems.forEach(async (e) => {
        const iconPath = `assets/icons/sidenav/${e.GroupName}.svg`;
        const exists = await fetch(iconPath, { method: 'HEAD' }).then(res => res.ok).catch(() => false);
        e.MenuIconURL = exists ? iconPath : 'assets/icons/sidenav/default.svg';
      });


      this.filteredSidebarItems = [...this.sidebarItems];
      this.expandedItems = this.sidebarItems.map(() => false);
    }).unsubscribe();

    const sideNav = document.querySelector<HTMLElement>('.sidenav');

    if (sideNav) {
      const observer = new MutationObserver(() => {
        this.isPinned = sideNav.classList.contains('pinned');
      });

      observer.observe(sideNav, {
        attributes: true,
        attributeFilter: ['class'],
      });

      // initialize it on load too
      this.isPinned = sideNav.classList.contains('pinned');
    }

  }



  // Function for search-bar
  filterSidebarItems(query: string) {

    const q = query.trim().toLowerCase();

    if (!q) {
      this.filteredSidebarItems = [...this.sidebarItems];
      this.expandedItems = this.sidebarItems.map(() => false);
      return;
    }

    this.filteredSidebarItems = [];
    this.expandedItems = [];

    this.sidebarItems.forEach((item: any) => {
      const matchedSubMenus = (item.SubMenus || []).filter((sub: any) =>
        sub.PrivilegeName?.toLowerCase().includes(q)
      );

      const parentMatches = item.GroupName?.toLowerCase().includes(q);

      if (parentMatches || matchedSubMenus.length > 0) {
        this.filteredSidebarItems.push({
          ...item,
          SubMenus: matchedSubMenus.length > 0 ? matchedSubMenus : item.SubMenus
        });

        this.expandedItems.push(true); // expand this item
      }
    });
  }



  // Function for Highlighting the search result
  highlightMatch(text: string): SafeHtml {
    const q = this.searchText.trim();
    if (!q) return this.sanitizer.bypassSecurityTrustHtml(text);
    const regex = new RegExp(`(${q})`, 'ig');
    const highlighted = text.replace(regex, `<mark>$1</mark>`);
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
  // old code
  

// highlightMatch(text: string): string {
//   const q = this.searchText.trim();
//   if (!q) return text;
//   const regex = new RegExp(`(${q})`, 'ig');
//   return text.replace(regex, `<span class="custom-highlight">$1</span>`);
// }

// highlightMatch(text: string): string {
//   const q = this.searchText.trim();
//   if (!q) return text;
//   const regex = new RegExp(`(${q})`, 'ig');
//   return text.replace(regex, `<span class="custom-highlight">$1</span>`);
// }


// old code
  // click(index: number) {
  //   if (this.expandedItems[index]) {
  //     this.expandedItems[index] = false;
  //   } else {
  //     this.expandedItems[index] = true;
  //   }
  // }
// old code

// click(index: number) {
//   this.expandedItems = this.expandedItems.map((_, i) => i === index);
// }

click(index: number,groupName:string) {
  const wasOpen = this.expandedItems[index];
  this.expandedItems = this.expandedItems.map(() => false);
  this.expandedItems[index] = !wasOpen;
  const groupname = groupName;
  this.groupName=groupName
  if (groupName!=='Dashboard') {
     localStorage.setItem('GroupName', groupname); // Store group name in localStorage
  }
  else{
    localStorage.removeItem('GroupName')
  }
 
}







  // Function to open search-bar when clicking on the search-icon
  openSearch() {

    this.isPinned = true;
    this.openedFromSearch = true; // ← track that it's opened via search
    this.pinStateChanged.emit(this.isPinned); // ← Notify parent about pinned state
    setTimeout(() => {
      const input = document.querySelector('.search-input') as HTMLInputElement;
      if (input) input.focus();
    }, 0);

    // Attach click-outside listener
    setTimeout(() => this.attachOutsideClickListener(), 100);

  }


  // Function to close Menubar when click outside
  private attachOutsideClickListener() {
    const clickHandler = (event: MouseEvent) => {
      const sidenavEl = document.getElementById('mySidenav');
      if (this.openedFromSearch && sidenavEl && !sidenavEl.contains(event.target as Node)) {
        this.isPinned = false;
        this.openedFromSearch = false;
        document.removeEventListener('click', clickHandler);
        this.pinStateChanged.emit(this.isPinned);
      }
    };

    document.addEventListener('click', clickHandler);

  }





  hoverOnSide(e: MouseEvent, i: number) {
    const sideNav = document.querySelector<HTMLElement>('.sidenav');
    const parentEl = (e.currentTarget as HTMLElement); // the `.parent` div

    if (!sideNav || sideNav.classList.contains('pinned')) return;

    e.stopPropagation();

    // Clear previous hovers
    clearTimeout(this.enterTimeout);
    clearTimeout(this.nextTimeout);
    document.querySelector('.hover-element')?.remove();

    const hElement = document.createElement('div');
    hElement.classList.add('hover-element');
    hElement.style.position = 'absolute';
    hElement.style.zIndex = '1000';
    hElement.style.backgroundColor = 'white';
    hElement.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
    hElement.style.borderRadius = '6px';
    hElement.style.padding = '4px';
    hElement.style.minWidth = '180px';

    // Add submenu links
    this.sidebarItems[i].SubMenus.forEach((sub: any) => {
      const a = document.createElement('a');
      a.classList.add('subtitle');
      a.setAttribute('style', `
      padding: 6px 10px;
      margin-left: 6px;
      text-decoration: none;
      font-size: 16px;
      color: var(--grey);
      font-family: "Rubik";
      display: block;
      border-left: 3px solid var(--border-color-75);
      cursor: pointer;
    `);
      if (this.router.isActive(sub.MenuURL, {
        paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'
      })) {
        a.style.backgroundColor = 'aliceblue';

        a.style.color = 'var(--infoblue)';
        a.style.borderLeft = '3px solid var(--infoblue)';
      } else {
        a.onmouseover = () => a.style.backgroundColor = 'var(--light)';
        a.onmouseleave = () => a.style.backgroundColor = 'white';
      }
      a.textContent = `   ${sub.PrivilegeName}`;
      a.addEventListener('click', () => {

      if (this.groupName!=='Dashboard') {
        localStorage.setItem('PrivilegeName', sub.PrivilegeName);
        }
        else{
          localStorage.removeItem('PrivilegeName')
        }

 
         
        this.router.navigate([sub.MenuURL]);
        document.querySelector('.hover-element')?.remove();
        
      });
      hElement.appendChild(a);
    });

    // Position next to the hovered `.parent`
    const parentRect = parentEl.getBoundingClientRect();
    hElement.style.top = `${parentRect.top + 20}px`;
    hElement.style.left = `${parentRect.right + 20}px`;

    document.body.appendChild(hElement);

    // Hover persistence
    hElement.onmouseover = () => {
      clearTimeout(this.nextTimeout);
      clearTimeout(this.enterTimeout);
    };
    hElement.onmouseleave = () => {
      document.querySelector('.hover-element')?.remove();
    };
  }




  leaveOnSide(e: MouseEvent, i: number) {
    const target = e.target as HTMLElement;
    if (this.nextTimeout != undefined) {
      clearTimeout(this.nextTimeout);
      this.nextTimeout = undefined;
      clearTimeout(this.enterTimeout);
      this.enterTimeout = undefined;
    }
    this.nextTimeout = setTimeout(() => {
      document.querySelector<HTMLElement>('.hover-element')?.remove();
      clearTimeout(this.nextTimeout);
      this.nextTimeout = undefined;
      clearTimeout(this.enterTimeout);
      this.enterTimeout = undefined;
    }, 1000);
  }


  checkActive(currentUrl: string, menuItem: any): boolean {
    return menuItem.SubMenus?.some((sub: any) => currentUrl === sub.MenuURL);
  }


  handleClick(url: string,privilegeName:string) {
    const currentModuleID = this.Auth.currentGrpSubject.value.ModuleID;
    // console.log(url)
    // Save PrivilegeName in localStorage
    localStorage.setItem('PrivilegeName', privilegeName);

    if (currentModuleID === 3 && this.router.url.endsWith(url)) {
      window.location.reload();
    }

  }


}
